<template>
  <div class="limitGuide">
    <div class="cnts">
      <iframe
        :src="limitPricePage"
        frameborder="0"
        @load="$emit('load')"
      ></iframe>

      <!-- TODO-  check : 배송상품 관련 안내 추가 기획문서에만 있고 디자인이 없음. iframe 으로 연동되므로 외부 디자인인가..  -->
      <div class="limitGuide-extra">
        <p class="comment">
          * 배송상품은 게임별 구매 가능 금액에 포함되지 않습니다.
        </p>
        <div class="descBox">
          <dl>
            <dt>게임별 구매한도</dt>
            <dd>
              <strong>메이플 스토리</strong>
              <span>200,000원</span>
            </dd>
            <dd>
              <strong>카트라이더</strong>
              <span>130,000원</span>
            </dd>
            <dd>
              <strong>FC Online</strong>
              <span>0원</span>
            </dd>
          </dl>
          <p class="comment">
            * 3개월간 구매이력이 있는 게임에 대해서 표시합니다.
          </p>
          <p class="comment">
            * 집계기준 :
            <span>8/31 08:00</span>
            기준
          </p>
        </div>
      </div>
      <!-- ./ limitGuide-extra -->
      <button type="button" class="btClose" @click="$emit('close')">
        <span class="accessibilityHide">닫기</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LimitGuide',
  props: ['limitPricePage'],
  methods: {
    ...mapActions('api', ['setDelay'])
  }
}
</script>

<style lang="scss">
.limitGuide {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 12px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;

  .cnts {
    position: relative;
    max-width: 640px;
    height: 100%;
    margin: 0 auto;
  }
  .btClose {
    position: absolute;
    top: 13px;
    right: 9px;
    width: 28px;
    height: 28px;
    background-color: transparent;
  }

  // 배송/펀딩상품 추가
  .limitGuide-extra {
    position: absolute;
    bottom: 100px;
    left: 15px;
    right: 15px;

    .comment {
      font-size: 12px;
      line-height: 1.7;
    }

    .descBox {
      margin: 10px 0;
      padding: 10px 15px;
      border-radius: 5px;
      font-size: 13px;
      background-color: #f7f7f7;
      dl {
        padding: 10px 0 20px;
        dt {
          font-weight: bold;
          font-size: 14px;
          line-height: 1.8;
        }
        dd {
          display: flex;
          justify-content: space-between;
          line-height: 1.5;
        }
      }
    }
  }
}
</style>
